/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import "./Layout.css";
import { useHistory } from "react-router-dom";

const Layoutcursos = () => {
    const History = useHistory();

    function Mostrarbarra() {

        let containerr = document.querySelector('.containerr');

            if(containerr.style.display === 'block') {
                containerr.style.display = 'none';
                } else {
                containerr.style.display = 'block';
                }
}

    return(
        <>
         <nav className="navbar navbar-default navbar-fixed-top" ></nav>
            {/* <button id='btn-div' className="Aside-c" onClick={(e) => { Mostrarbarra(e) }} ><img src="Menuprincipal.png" className="desktopmenu" alt="menuprincipal"></img></button> */}
                <div className="logocursos" >
                    <img onClick={() => {History.push("/");}} src="LOGO.png" className="desktoplogo-layout" alt="logopos"></img>
                    <img id='btn-div' className="Aside-c" onClick={(e) => { Mostrarbarra(e) }} src="Menuprincipal.png" alt="menuprincipal"></img>
                    {/* <h1 className="pos-c">PÓS</h1>
                        <h4 className="odonto-c">ODONTO</h4>
                        <h4 className="unifacex-c">UNIFACEX</h4> */}
                </div>
                <div className="esquerdo"> 
                    <div className="baixo">
                    </div>
                </div>
                        <strong className="publico">PÚBLICO ALVO</strong>   
                        <strong className="diferencias">DIFERENCIAIS <br/>
                                                        DO CURSO</strong>   
                        <strong className="coordenacao">COORDENAÇÃO</strong>    
                        <strong className="encontros-c">ENCONTROS</strong>   
                        <strong className="carga-c">CARGA <br/>
                                                    HORÁRIA</strong>   
                        <strong className="aula-c">TIPO DE AULA</strong>   
                        <strong className="investimento-c">INVESTIMENTO</strong>   
                        <a target="_blank" rel="noreferrer" href='https://processoseletivo.unifacex.com.br/iniciar-inscricao' ><button className="Matricula"><h4>MATRICULA</h4></button></a>   
                    {/* <a href='https://processoseletivo.unifacex.com.br/iniciar-inscricao' ></a> */}
                <small className="download">FAÇA O DOWNLOAD</small>

                <aside className="barralateralll">
                    {/* <button id='btn-div'  onClick={(e) => { Mostrarbarra(e) }} className="Aside-interno" ><MenuIcon/></button> */}
                    <div className="containerr" id="barralaterall">
                        <button id='btn-div'  onClick={(e) => { Mostrarbarra(e) }} className="Aside-interno" ><img src="Menuinterno.png" className="desktopmenuinterno" alt="menuinterno"></img></button>
                            <br/><br/><img id="menu-endodontia" onClick={() => {History.push("/endodontia");}} src="Endodontia.png" className="desktopmenuendodontia" alt="menuendodontia"></img><br/><br/>
                            <img id="menu-imaginologia" onClick={() => {History.push("/imaginologia");}} src="Imaginologia.png" className="desktopmenuimaginologia" alt="menuimaginologia"></img><br/><br/>
                            <img id="menu-implantodontia" onClick={() => {History.push("/implantodontia");}} src="Implantodontia.png" className="desktopmenuimplantodontia" alt="menuimplantodontia"></img><br/><br/>
                            <img id="menu-pacientesespeciais" onClick={() => {History.push("/pacientesespeciais");}} src="Odontologia.png" className="desktopmenuodontologia" alt="menuodontologia"></img>
                            <img id="menu-line" src="Line.png" className="desktopmenuline" alt="logopos"></img>
                                <a href="http://unifacex.com.br/" target="_blank" rel="noreferrer"><img id="menu-conheca" src="conhecaunifacex.png" className="desktopconheca" alt="conhecaunifacex"></img></a>
                            <img id="menu-fale" src="faleconosco.png" className="desktofaleconosco" alt="logopos"></img>

                                {/* <a href="!#" id="menu-endodontia" onClick={() => {History.push("/endodontia");}}>ENDODONTIA </a><br/><br/>
                                <a href="!#" id="menu-imaginologia" onClick={() => {History.push("/imaginologia");}}>IMAGINOLOGIA</a><br/><br/>
                                <a href="!#" id="menu-implantodontia" onClick={() => {History.push("/implantodontia");}}>IMPLANTODONTIA</a><br/><br/>
                                <a href="!#" id="menu-pacientesespeciais" onClick={() => {History.push("/pacientesespeciais");}}>ODONTOLOGIA - PNE</a> */}
                    </div>
                </aside>
                
        </>
    )
};

export default Layoutcursos;